import { Button, makeStyles } from "@material-ui/core";

const Card60 = ({ index, news }) => {
  const classes = useStyles();

  return (
    <div className={classes.cardBox}>
      <div className={classes.leftCard}>
        <img src={news?.images[0]} alt="Imag 1" />
      </div>
      <div className={classes.rightCard}>
        <h5 className="heading">{news?.heading}</h5>
        <div className="text">
          {news?.contents?.map((val, index) => (
            <div key={index}>
              {val} <br />
            </div>
          ))}
          <Button variant="contained" color="primary">
            Read More
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Card60;

const useStyles = makeStyles((theme) => ({
  cardBox: {
    display: "flex",
    justifyContent: "center",
    margin: ".5rem 0",
    boxShadow: ".1rem -.1rem .75rem #a1a1a1, -.1rem .1rem .75rem #a1a1a1",
    borderRadius: ".75rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      width: "100%",
      heightL: "100%",
      margin: ".5rem",
    },
  },
  leftCard: {
    width: "14rem",
    height: "inherit",
    borderRadius: ".75rem 0  0 .75rem",
    overflow: "hidden",
    "& img": {
      width: "inherit",
      height: "inherit",
      objectFit: "cover",
      aspectRatio: "16/9",
    },
    [theme.breakpoints.down("sm")]: {
      width: "inherit",
      height: "100%",
      margin: "0",
      borderRadius: " .75rem .75rem 0 0",
    },
  },
  rightCard: {
    display: "flex",
    flexDirection: "column",
    height: "12rem",
    width: "26rem",
    borderRadius: "0 .75rem .75rem 0",
    // backgroundColor: "#bb280b",
    [theme.breakpoints.down("sm")]: {
      width: "inherit",
      margin: "0",
      borderRadius: 0,
    },
    "& .heading": {
      backgroundColor: "#fafafa",
      height: "3rem",
      margin: "0rem",
      padding: "0rem 0.5rem",
      fontWeight: "bold",
      borderRadius: "0 .75rem 0 0",
      [theme.breakpoints.down("md")]: {
        margin: ".25rem 0",
        borderRadius: "0",
      },
    },
    "& .text": {
      margin: "0.5rem",
      flex: 1,
      borderRadius: "0 0 .75rem 0",
      backgroundColor: "#fff",
      overflow: "hidden",
      [theme.breakpoints.down("md")]: {
        margin: ".25rem",
        borderRadius: "0 0 .75rem .75rem",
      },
    },
  },
}));
